import React from 'react';
import { func, node, number } from 'prop-types';
import { StyledStep, StyledSVG } from './styles';

const Step = ({ activeStep, children, index, onClick }) => {
  const handleClick = onClick(index);
  const isDisabled = activeStep < index;

  return (
    <div style={{ flex: '0 0 auto' }}>
      <StyledStep isDisabled={isDisabled} alignItems='center' flexDirection='column' onClick={handleClick}>
        <span style={{ display: 'block', paddingRight: '8px', zIndex: 1 }}>
          <StyledSVG isDisabled={isDisabled} viewBox='0 0 24 24' data-testid={`step-${index}`}>
            {index < activeStep ? (
              // eslint-disable-next-line max-len
              <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' />
            ) : (
              <>
                <circle cx='12' cy='12' r='10' />
                <text x='12' y='16' textAnchor='middle' fontSize='12' fill='#fff'>
                  {index + 1}
                </text>
              </>
            )}
          </StyledSVG>
        </span>
        {children}
      </StyledStep>
    </div>
  );
};

Step.propTypes = {
  activeStep: number.isRequired,
  children: node.isRequired,
  index: number.isRequired,
  onClick: func.isRequired
};

export default Step;
